import { useState } from 'react';
import cx from 'classnames';
import { v4 as uuidv4 } from 'uuid';

import { styled } from '../../../../stitches.config';
import { AtomBackground } from './AtomBackground';
import { AtomTextGroup } from './AtomTextGroup';

const AtomGroup = styled('g', {
  'userSelect': 'none',
  '&:hover .atomContainer': {
    stroke: '#ddd',
  },
  '&:hover .atomBackground': {
    fill: '#ddd',
  },
});

const BlankAtom = styled('circle', {
  '&:hover': {
    opacity: 1,
  },
});

export function Atom(props: any) {
  const { atom, title, warning = false, ...restProps } = props;

  const [lifetimeId] = useState<string>(uuidv4());

  const innerStroke = warning && (
    <AtomTextGroup
      className="atomContainer"
      center={atom.centerLabel}
      side={atom.sideLabel}
      pos={atom.pos}
      color="none"
      stroke="white"
      strokeWidth="3px"
    />
  );

  return (
    <AtomGroup {...restProps} className={cx(restProps.className, { 'carbon-atom': !atom.centerLabel }, 'atom-group')}>
      {!atom.centerLabel ? (
        <BlankAtom
          cx={atom.pos[0].toFixed(2)}
          cy={atom.pos[1].toFixed(2)}
          r={warning ? '15px' : '25px'}
          fill={warning ? 'red' : 'lightgrey'}
          stroke="none"
          opacity={warning ? '0.5' : '0'}
          data-test={`svg-atom-C-${lifetimeId}`}
        />
      ) : (
        <>
          <AtomBackground
            className="atomBackground"
            center={atom.centerLabel}
            side={atom.sideLabel}
            pos={atom.pos}
            rectProps={{ rx: 5, ry: 5 }}
            color="white"
          />
          <AtomTextGroup
            className="atomContainer"
            center={atom.centerLabel}
            side={atom.sideLabel}
            pos={atom.pos}
            color="none"
            stroke={warning ? 'pink' : 'white'}
            data-test={`svg-atom-${atom.centerLabel.parts.map((p: any) => p.text)}${
              atom.sideLabel ? atom.sideLabel.parts.map((p: any) => p.text) : ''
            }-${lifetimeId}`}
          />
          {innerStroke}
          <AtomTextGroup center={atom.centerLabel} side={atom.sideLabel} pos={atom.pos} color={atom.color} />
          <title>{title}</title>
        </>
      )}
    </AtomGroup>
  );
}
